import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    children: [
      {
        component: () =>
          import("pages/contactMailingLists/ContactMailingListEdit.vue"),
        meta: {
          title: "New Contact Mailing List",
        },
        name: "contact-mailing-list-new",
        path: "new",
      },
      {
        component: () =>
          import("pages/contactMailingLists/ContactMailingListEdit.vue"),
        meta: {
          title: "Edit Contact Mailing List",
        },
        name: "contact-mailing-list-edit",
        path: ":id",
        props: true,
      },
      {
        component: () =>
          import("pages/contactMailingLists/ContactMailingLists.vue"),
        meta: {
          title: "Contact Mailing Lists",
        },
        name: "contact-mailing-lists-index",
        path: "",
        props: (route) => typecastRouteProps(route),
      },
    ],
    component: () =>
      import("pages/contactMailingLists/ContactMailingListsIndex.vue"),
    path: "/contact-mailing-lists",
  },
];
